import { format, Instance } from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from './assetService';
import { LanguageService } from './languageService';
import { ModelService } from './modelService';

export class CouponService extends ModelService {
    static readonly inject = ['instances', 'languageService', 'assetService'];

    constructor(
        instances: Instance,
        $languageService: LanguageService,
        $assetService: AssetService,
    ) {
        super(
            'coupon-coupons-name',
            instances,
            $languageService,
            $assetService,
        );
    }

    checkCodeByOrganization(organizationId: string, code: string) {
        return this.http.get(
            format('/api/v1/organizations/{0}/coupons/check/{1}.json', [
                organizationId,
                code,
            ]),
        );
    }
}

export const couponService = app.service('couponService', CouponService);
